import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import React from 'react';
import { provincesData } from '@applyboard/ab-common';
import IndianProvincesContext from "./IndianProvincesContext";
import { OUTSIDE_INDIA } from "../../Common/Constants";
export var getIndianProvinces = function getIndianProvinces() {
  var provinces = provincesData.provinces.filter(function (province) {
    return province.country === 'IN';
  }).sort(function (a, b) {
    return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
  }).map(function (p) {
    return {
      name: p.label,
      code: p.label
    };
  });
  var index = provinces.findIndex(function (p) {
    return p.name === OUTSIDE_INDIA;
  });
  if (index > -1) {
    provinces.push(provinces[index]);
    provinces.splice(index, 1);
  }
  return provinces;
};
var ProvincesProvider = function ProvincesProvider(_ref) {
  var children = _ref.children;
  var provinces = getIndianProvinces();
  var value = {
    data: provinces,
    isLoading: false
  };
  return /*#__PURE__*/React.createElement(IndianProvincesContext.Provider, {
    value: value
  }, children);
};
export default ProvincesProvider;